import React from 'react'
import { useSelector } from 'react-redux'

// Components
import { If } from 'src/deprecated/Conditionals'
import { Player } from 'src/Components/shared/Player'
import { SlideOnMount } from 'src/Components/shared/Animations'

// Selectors
import {
  selectYourMarketDemandVideoId,
  selectYourMarketDemandVideoType
} from 'src/store/selectors/videos'
import { selectLatestMarketDemandKey } from 'src/store/selectors/marketRecord/index'

// Styles
import styles from './MarketSpotlightVideo.module.scss'

const MarketSpotlightVideo = () => {
  const demandKey = useSelector(selectLatestMarketDemandKey)
  const videoId = useSelector(selectYourMarketDemandVideoId(demandKey))
  const videoType = useSelector(selectYourMarketDemandVideoType(demandKey))

  const showVideo = demandKey && videoType && videoId

  return (
    <If condition={showVideo}>
      <SlideOnMount>
        <Player
          className={styles.video}
          videoType={videoType}
          videoId={videoId}
        />
      </SlideOnMount>
    </If>
  )
}

export default MarketSpotlightVideo
